import React from "react";
import { Button, Modal as AntModal } from "antd";
import { useTranslation } from "react-i18next";
import { GiftFilled } from "@assets";
import styled from "styled-components";
import moment from "moment";

const Modal = styled(AntModal)`

.ant-modal-content {
  padding: 0 14px 16px 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #B51F07 0%, #6D1304 100%);
  text-align: center;
}

.ant-btn {
  height: 44px;
  margin-top: 12px;
  border: none !important;
  border-radius: 29px !important;
  background: linear-gradient(180deg, #D18228 0%, #F6FF00 100%) !important;

  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 1.5 !important;
  color: #181E1F !important;

  :hover {
    color: #181E1F !important;
  }
}

`;

const ModalTitle = styled.div`
padding-top: 11px;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #F9F9F9;
`;

const SubTitle = styled.div`
padding-top: 4px;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #FFB829;
`;

const BoldText = styled.p`
padding: 18px 0;
font-size: 23px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #f9f9f9;
`;

const Text = styled.span`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #fff;
`;

const LightText = styled(Text)`
color: #E8A442;
`;

const GiftIcon = styled(GiftFilled)`
margin-top: -33px;
`;

const CongratsModal = ({ data, handleOk }) => {
    const { t } = useTranslation();

    return (
        <Modal
            centered
            open={data.open}
            closable={false}
            footer={null}
            width={320}
            className="pocket-money-modal"
        >
            <GiftIcon />
            <ModalTitle>
                {t("spin.spinWinningTitle")}
            </ModalTitle>
            <SubTitle>
                {t("spin.spinWinningDescription")}
            </SubTitle>
            <BoldText>
                {`${data.winning_amount} Ks.`}
            </BoldText>
            <Text>
                {t("spin.expiredMessage")}
            </Text>&nbsp;
            <LightText>
                {moment.unix(data.expired_on).format('DD MMMM YYYY')}
            </LightText>
            <Button
                type="primary"
                onClick={handleOk}
            >
                {t("common.ok")}
            </Button>
        </Modal>
    );
};

export default CongratsModal;
